import React, {useMemo, useState} from 'react';

import {Bell, CreditCard, FileText, Shield, Store, User} from 'lucide-react';
import StaffSettings from "./StaffSettings";
import {SettingTypes, useSettings} from "../settings/useSettings";
import {useBreakpoint} from "../utils/useBreakpoint";
import {Locations} from "../settings/locations/locations";
import {Branding} from "../settings/branding/branding";
import {ApiKeys} from "../settings/apiKeys/apiKeys";
import {MobileSetting} from "../settings/mobileSetting/mobileSettings";
import {SubscriptionTierType} from "../dictionaries/plans";
import {SubscriptionSuccessfulModal} from "../billing/components/subscriptionSuccessfulModal";
import {Divider, Snippet} from "@nextui-org/react";
import classNames from "classnames";
import {useBusinessDetails} from "../settings/businessDetails/useBusinessDetails";
import {InputEdit} from "../components/inputEdit/InputEdit";
import {UpgradeBanner} from "../billing/components/upgradeBanner";
import {Path} from "../path";
import {truncate} from "lodash";
import {AsButton, AsIconButton, reactSelectStyles} from "../subframe";
import {useBusinessPolicies} from "../settings/businessPolicies/useBusinessPolicies";
import {Switch} from "@nextui-org/switch";
import {FadeInSlide} from "../motions/fadeInSlide";
import Select from "react-select";
import {Icon} from "@subframe/core";
import {PlusIcon} from "@heroicons/react/24/solid";
import {BusinessPolicies} from "../settings/businessPolicies/businessPolicies";
import {Security} from "../user/components/security/security";
import Payments from "../settings/payments/Payments";
import NotificationSettings from "../settings/notifications/NotificationSettings";
import {RESERVE_BASE_URL} from "../utils/config";


const BusinessInfo = () => {
    const {account, onUpdateAccount, onCopyBookingUrl, showCopiedTooltip} = useBusinessDetails();

    return (<div className="space-y-6">
        <Branding/>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <InputEdit
                        defaultValue={account?.name}
                        label="Business name"
                        name="name"
                        onSave={(value) => onUpdateAccount({...value})}
                        valueClassName="text-body-bold font-body-bold text-neutral-900"
                    />
                </div>

                {/*<div>*/}
                {/*    <label className="block text-sm font-medium text-gray-700 mb-2">*/}
                {/*        Address*/}
                {/*    </label>*/}
                {/*    <input*/}
                {/*        type="text"*/}
                {/*        defaultValue=""*/}
                {/*        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div>*/}
                {/*    <label className="block text-sm font-medium text-gray-700 mb-2">*/}
                {/*        Business Type*/}
                {/*    </label>*/}
                {/*    <select*/}
                {/*        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">*/}
                {/*        <option>Medical Spa</option>*/}
                {/*        <option>Dermatology Clinic</option>*/}
                {/*        <option>Aesthetic Center</option>*/}
                {/*        <option>Wellness Clinic</option>*/}
                {/*    </select>*/}
                {/*</div>*/}
            </div>



            {/*<div className="grid grid-cols-1 md:grid-cols-2 gap-6">*/}
            {/*    <div>*/}
            {/*        <label className="block text-sm font-medium text-gray-700 mb-2">*/}
            {/*            Phone Number*/}
            {/*        </label>*/}
            {/*        <input*/}
            {/*            type="tel"*/}
            {/*            defaultValue=""*/}
            {/*            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    <div>*/}
            {/*        <label className="block text-sm font-medium text-gray-700 mb-2">*/}
            {/*            Email*/}
            {/*        </label>*/}
            {/*        <input*/}
            {/*            type="email"*/}
            {/*            defaultValue=""*/}
            {/*            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className={' flex flex-col gap-4'}>
                <InputEdit
                    defaultValue={account?.description}
                    label="Business description"
                    name="description"
                    onSave={(value) => onUpdateAccount({...value})}
                    valueClassName="text-body-bold font-body-bold text-neutral-900"
                    truncateLength={160}
                />


                <InputEdit
                    defaultValue={account?.website}
                    label="Website"
                    name="website"
                    onSave={(value) => onUpdateAccount({...value})}
                    valueClassName="text-body-bold font-body-bold text-neutral-900"
                />


            </div>
            <div className="flex flex-col">
                <p className="text-sm text-[#71717A]">Booking URLs</p>
                        <div className="flex relative items-center justify-between">
                        <Snippet
                            classNames={{
                                base: "relative w-full bg-transparent px-0 py-0 font-inter",
                                pre: "font-inter font-semibold text-medium text-neutral-900",
                            }}
                            hideCopyButton
                            hideSymbol
                        >
                            {truncate(`${RESERVE_BASE_URL}${account?.bookingLink}`, {
                                length: 55,
                            })}
                        </Snippet>
                        <div className="relative">
                            <p
                                className={classNames(" duration-300 text-xs text-neutral-900 absolute bg-white p-1 -top-7 -left-7", {
                                    "opacity-0": !showCopiedTooltip, "opacity-100": showCopiedTooltip,
                                })}
                            >
                                Copied!
                            </p>
                            <AsIconButton
                                variant="ghost"
                                leadingIcon="FeatherCopy"
                                size="xs"
                                // className="absolute right-0"
                                onClick={() => onCopyBookingUrl()}
                            />
                        </div>
                    </div>
                {/*)}*/}
            </div>

            <div>
                <h4 className="text-base font-medium text-gray-900 mb-4">Business Location</h4>
                <div className="space-y-4">
                    <Locations/>
                </div>
            </div>

        </div>)
}




const Settings1: React.FC = () => {
    const {
        onMenuPress,
        path,
        logout,
        account,
        user,
        showSubscriptionSuccessModal,
        setShowSubscriptionSuccessModal,
        newlySubscribedPlan,
    } = useSettings();
    const {isBelowSm} = useBreakpoint("sm");


    const view = () => {
        switch (path) {
            case SettingTypes.BUSINESS_DETAILS:
                return <BusinessInfo/>;
            case SettingTypes.STAFF:
                return <StaffSettings/>;
            case SettingTypes.PAYMENTS:
                return <Payments/>;
            case SettingTypes.BUSINESS_POLICIES:
                return <BusinessPolicies/>;
            case SettingTypes.NOTIFICATIONS:
                return <NotificationSettings/>;
            case SettingTypes.SECURITY:
                return <Security/>;
            default:
                return <BusinessInfo/>;
        }
    };


    const [activeSection, setActiveSection] = useState('business');


    const sections = [
        {key: 'businessDetails', label: 'Business Info', icon: Store},
        {key: 'staffDetails', label: 'Staff', icon: User},
        {key: 'payments', label: 'Payments', icon: CreditCard},
        {key: 'businessPolicies', label: 'Business Policies',icon: FileText},
        {key: 'notifications', label: 'Notifications', icon: Bell},
        {key: 'security', label: 'Security', icon: Shield},
    ];
    const sectionForEmployee = [
        {key: 'security', label: 'Security', icon: Shield},
    ];

    const sectionsViaRole=useMemo(()=>user.role?.toLowerCase()=== 'admin' ? sections :sectionForEmployee ,[user?.role])


    if (isBelowSm) {
        return <MobileSetting onLogout={logout} account={account} user={user}/>;
    }

    return (<>
            <SubscriptionSuccessfulModal
                open={showSubscriptionSuccessModal}
                onOpenChange={setShowSubscriptionSuccessModal}
                newlySubscribedPlan={newlySubscribedPlan as SubscriptionTierType}
            />
            <div className="space-y-6 px-2">
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                    {/* Settings Navigation */}
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-lg border border-gray-200 p-6">
                            <h2 className="text-lg font-medium text-gray-900 mb-4">Settings</h2>
                            <nav className="space-y-2">
                                {sections.map((section) => {
                                    const Icon = section.icon;
                                    return (<button
                                            key={section.key}
                                            onClick={() => onMenuPress(section.key)}
                                            className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors ${path === section.key ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}`}
                                        >
                                            <Icon className="w-5 h-5"/>
                                            <span className="text-sm">{section.label}</span>
                                        </button>);
                                })}
                            </nav>


                        </div>
                    </div>

                    {/* Settings Content */}
                    <div className="lg:col-span-3">
                        <div className="bg-white rounded-lg border border-gray-200">
                            <div className="p-6 border-b border-gray-200">
                                <h3 className="text-xl font-semibold text-gray-900">
                                    {sections.find(s => s.key === path)?.label}
                                </h3>
                            </div>

                            <div className="p-6">
                                {view()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
};

export default Settings1;
